(function () {
    window.dataLayer = window.dataLayer || [];
    /* function gtag() {
        dataLayer.push(arguments);
    } */

    const ID_TYPE = "shopify";
    const PRODUCT_COUNTRY_CODE = "US";
    const CAPITALIZE_SKU = false;

    const analyticsData = window.analyticsData || {};
    const currency = analyticsData.currency || 'USD';

    // Helper: Get product item object for GA4
    function getProductItem(product, variantId) {
        if (!product) return null;
        const variant = product.variants.find((v) => v.id === variantId) || product.variants[0];
        return {
            item_id: variant ? variant.id.toString() : product.id.toString(),
            item_name: product.title,
            item_brand: product.vendor,
            price: variant ? (variant.price / 100).toFixed(2) : (product.price / 100).toFixed(2),
            item_variant: variant ? variant.title : null,
            quantity: 1,
            item_category: product.type // Optional: Category
        };
    }

    // 1. view_item (PDP)
    /* if (analyticsData.template === 'product' && analyticsData.product) {
        const item = getProductItem(analyticsData.product, analyticsData.currentVariantId);
        if (item) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: currency || null,
                    value: item?.price || null,
                    items: item ? [item] : []
                }
            });
        }
    } */

    // 2. add_to_cart (Listener via PubSub)
    // We assume PUB_SUB_EVENTS are available since theme.liquid loads constants.js/pubsub.js
    /* if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
            if (data.source === 'product-form') {
                const variantId = parseInt(data.productVariantId);

                // If we are on PDP and the variant matches, use the global product data
                if (analyticsData.template === 'product' && analyticsData.product) {
                    const product = analyticsData.product;
                    // Check if the variant belongs to this product
                    const variant = product.variants.find(v => v.id === variantId);
                    if (variant) {
                        const item = getProductItem(product, variantId);
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: currency || null,
                                value: item?.price || null,
                                items: item ? [item] : []
                            }
                        });
                    }
                }
                // TODO: Handle Quick Add on Collection Page (requires fetching product data or reading from DOM)
            }
        });
    } */

    // 3. view_cart (Cart Drawer or Page)
    // If we utilize the 'cart-drawer' opening event.
    // We can listen for a class change on cart-drawer or a specific event if one exists.
    // cart-drawer.js adds 'active' class.
    const createDrawerCartItems = (cart, ID_TYPE, PRODUCT_COUNTRY_CODE, CAPITALIZE_SKU) => {
        if (!cart?.items || !Array.isArray(cart.items)) return [];

        return cart.items.map((lineItem) => {
        let itemId;

        if (ID_TYPE === "shopify") {
            itemId = "shopify_" + PRODUCT_COUNTRY_CODE + "_" + lineItem.product_id + "_" + lineItem.variant_id;
        } else if (ID_TYPE === "parent_id") {
            itemId = lineItem.product_id;
        } else if (ID_TYPE === "sku") {
            itemId = lineItem.sku || lineItem.variant_id;
            if (itemId && CAPITALIZE_SKU) {
            itemId = itemId.toString().toUpperCase();
            }
        } else {
            itemId = lineItem.variant_id;
        }

        const price =
            lineItem.final_price != null
            ? (lineItem.final_price / 100).toFixed(2)
            : lineItem.price != null
                ? (lineItem.price / 100).toFixed(2)
                : null;

        return {
            item_id: itemId ? itemId.toString() : null,
            id: itemId ? itemId.toString() : null,
            ecomm_prodid: itemId ? itemId.toString() : null,
            ecomm_pagetype: "cart",
            ecomm_totalvalue:
            lineItem.final_line_price != null
                ? (lineItem.final_line_price / 100).toFixed(2)
                : null,
            item_name: lineItem.product_title || null,
            item_brand: lineItem.vendor || null,
            item_category: lineItem.product_type || null,
            item_variant: lineItem.variant_title || null,
            price: price,
            quantity: lineItem.quantity || 1
        };
        });
    };
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
        let lastViewCartSignature = "";
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    cartDrawer.classList.contains('active')
                ) {
                    // Drawer opened
                    // We need to fetch cart items to populate 'items' array? 
                    // Or just fire view_cart with minimal data?
                    // Ideally we should track the items in the cart.
                    // window.analyticsData.cart only has initial state.
                    // We might need to fetch /cart.js to get current state if it changed.
                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            const items = createDrawerCartItems(
                                cart,
                                ID_TYPE,
                                PRODUCT_COUNTRY_CODE,
                                CAPITALIZE_SKU
                            );

                            const signature = JSON.stringify({
                                item_count: cart.item_count,
                                total_price: cart.total_price
                            });

                            if (signature === lastViewCartSignature) return;
                            lastViewCartSignature = signature;

                            //console.log('see on cart drawer open', items);

                            window.dataLayer.push({ ecommerce: null });
                            window.dataLayer.push({
                                event: "view_cart",
                                ecommerce: {
                                    currency: cart.currency || null,
                                    value: cart.total_price != null
                                        ? (cart.total_price / 100).toFixed(2)
                                        : null,
                                    google_business_vertical: "retail",
                                    items: items
                                }
                            });

                            /* const items = cart.items.map(lineItem => ({
                                item_id: lineItem.variant_id.toString(),
                                item_name: lineItem.product_title,
                                price: (lineItem.price / 100).toFixed(2),
                                quantity: lineItem.quantity,
                                item_variant: lineItem.variant_title
                            }));

                            gtag('event', 'view_cart', {
                                currency: currency,
                                value: (cart.total_price / 100).toFixed(2),
                                items: items
                            }); */
                        })
                        .catch((error) => {
                            console.error("view_cart drawer error", error);
                        });
                }
            });
        });
        observer.observe(cartDrawer, { attributes: true });
    }

    // 4. begin_checkout (Button Click)
    /* document.addEventListener('click', (e) => {
        if (e.target.matches('[name="checkout"], [name="checkout"] *')) {
            // Fetch current cart to ensure we have the items
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const items = cart.items.map(lineItem => ({
                        item_id: lineItem.variant_id.toString(),
                        item_name: lineItem.product_title,
                        price: (lineItem.price / 100).toFixed(2),
                        quantity: lineItem.quantity,
                        item_variant: lineItem.variant_title
                    }));

                    gtag('event', 'begin_checkout', {
                        currency: currency,
                        value: (cart.total_price / 100).toFixed(2),
                        items: items
                    });
                });
        }
    }); */

})();